import React from 'react';
import styled from 'styled-components';

import {AuthContext} from "../../authContext";
import citycadGreyLogo from "../../assets/images/icons/element.svg";
import urbFileIcon from "../../assets/images/icons/urb-doc-48.png";

const ProjectContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0px 5px 0px;
  border-bottom: 1px solid #cdcdcd;
  cursor: pointer;
  color: #000000;
  text-decoration: none;
  width: 100%;
  
  &:hover {
    background-color: #dfead2;
  }
`;

class ProjectTable extends React.Component {
  static contextType = AuthContext;
  goToProject = id => {
    this.context.navigate(`/project/${id}`);
  };
  render() {
    if (this.props.data.length === 0) {
      return (
        <div style={{paddingTop:"5px", borderTop:"1px solid #cdcdcd"}}>
          <h4>Create a project...</h4>
          <p>
            When you have created a project you can then easily upload and download your urban models directly from CityCAD.
          </p>
          <p>
            If you have added any other team members to your Holistic City account, they will be able to download and work on the models as well.
          </p>
          <p>
            Your files will be stored in secure cloud servers based in the UK and provided by Microsoft Azure.
            If you have any queries about online projects or cloud storage please contact support@holisticcity.co.uk
          </p>
        </div>
      )
    }
    return (
      <div style={{borderTop: "1px solid #cdcdcd", width: "100%"}}>
        {
          this.props.data.map(project => {
            return (
              <ProjectContainer key={project.id} onClick={() => { this.goToProject(project.id)}}>
                <div style={{display:"flex", justifyContent:"flex-start", alignItems:"center"}}>
                  <div style={{marginTop:"2px", marginRight:"5px"}}>
                    <img src={citycadGreyLogo} alt={`CityCAD grey logo`} style={{width:"24px"}}/>
                  </div>
                  <div style={{minWidth: "40%", textAlign:"left"}}>
                    {project.name}{project.isCanEdit !== "1" && ` (read only)`}
                  </div>
                </div>
                {
                  project.resourcesCount > 0
                  &&
                  <div style={{display:"flex", alignItems:"center", width:"32px"}}>
                    <img src={urbFileIcon} alt={`CityCAD file icon`} style={{width:"16px", marginRight:"5px"}}/>
                    <div>{project.resourcesCount}</div>
                  </div>
                }
              </ProjectContainer>
            )
          })
        }
      </div>
    )
  }
};

export default ProjectTable;
